import React from 'react'
import { FormControl, Grid, TextField, Typography } from '@mui/material'

export const DateChangeSection = ({ useFetchInit }) => {
    const { 
        //------------- Generales
        location,
        paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

        // ------------------------------------------------ Formularios
        const { FormRequestGlobal } = Forms
        const { formState, onInputChange } = FormRequestGlobal

        const { formOpeningMode} = globalStates

        //------------------------------------------------- Fech data

    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="credito_dia_pago"> * Dia de pago</label>
                        <TextField
                            id='credito_dia_pago'
                            name='credito_dia_pago'
                            value={ formState.credito_dia_pago } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Día de pago'
                            type='date'
                            variant='filled'
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="gestion_nuevo_dia_pago"> * Nuevo dia de pago</label>
                        <TextField
                            id='gestion_nuevo_dia_pago'
                            name='gestion_nuevo_dia_pago'
                            value={ formState.gestion_nuevo_dia_pago } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Nuevo dia de pago'
                            type='date'
                            variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                            InputProps={{
                                readOnly: (formOpeningMode==='READONLY') ? true: false 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="gestion_descripcion">Descripcion</label>
                        <TextField
                            id='gestion_descripcion'
                            name='gestion_descripcion'
                            value={ formState.gestion_descripcion } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Descripcion'
                            type='text'
                            multiline
                            rows={5}
                            variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                            InputProps={{
                                readOnly: (formOpeningMode==='READONLY') ? true: false 
                            }}
                            
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
